// extracted by mini-css-extract-plugin
module.exports = {"movecost":"MoveCost_movecost__5MCaP"};